var today = new Date();
export const todaysDate = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear();
export const dateFormat = "DD/MM/YYYY";